export default __webpack_public_path__ + "static/redirects-6703448a2ca2905db02a6b088b5ab064.svg";